module.exports = __webpack_public_path__ + "static/media/20201121_220519_180_IMG_0991.3619880f.jpg";